import React from "react";

const About = () => {
  return (
    <section id="about" className="py-20 bg-muted">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* About Text */}
          <div>
            <h2 className="text-4xl font-bold text-foreground mb-6">
              About ConstructCo
            </h2>
            <p className="text-muted-foreground text-lg mb-6">
              With over 15 years of experience, we specialize in creating
              beautiful residential spaces that combine functionality with
              exceptional design. Our team of skilled craftsmen and designers
              work together to bring your vision to life.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <div className="text-3xl font-bold text-primary mb-2">15+</div>
                <div className="text-muted-foreground">Years Experience</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary mb-2">200+</div>
                <div className="text-muted-foreground">Projects Completed</div>
              </div>
            </div>
          </div>

          {/* About Image */}
          <div className="relative">
            <img
              src="assets/abhist.png"
              alt="Construction team working together on residential building site"
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
